import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

import { setPatientMedicalHistoryOptions } from '../store/options.actions'
import { OptionsService } from '../services/options.service'
import { filterHiddenOptions } from '../../../utilities/options.util'
import { IHideableOptionsResponse } from '../store/options.types'

export function* setMedicalHistoryOptions() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)
  try {
    const medicalHistoryResponse: IHideableOptionsResponse = yield call([
      optionsService,
      optionsService.getMedicalHistoryBasicButtonWallOptions,
    ])
    const { entity } = medicalHistoryResponse
    yield put(setPatientMedicalHistoryOptions(filterHiddenOptions(entity)))
  } catch (e) {
    yield put(throwPcrException(`setMedicalHistoryOptions() error: ${e}`))
  }
}

export function* setMedicalHistoryOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], setMedicalHistoryOptions)
}
